
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import Tag from '~/components/atoms/Tag.vue'
import SexualitySlider from '~/components/molecules/SexualitySlider.vue'
import SexualityPercentBar from '~/components/molecules/SexualityPercentBar.vue'
import { Gender, GenderInfoList } from '~/types/api/result'
import * as mGender from '~/consts/genders'

export default Vue.extend({
  components: {
    Tag,
    SexualitySlider,
    SexualityPercentBar,
  },
  props: {
    genderInfoList: {
      type: Object,
      required: true,
    } as PropOptions<GenderInfoList>,
  },
  computed: {
    score() {
      const genderInfoList = this.genderInfoList
      if (genderInfoList.genderTypeCode === 'gender_identity') {
        return ''
      }
      if (genderInfoList.genderTypeCode === 'gender_expression') {
        return ''
      }
      if (genderInfoList.gender.id === 'questioning') {
        return ''
      }

      let score = genderInfoList.gender.score
      if (genderInfoList.gender.id === 'gay' ||
        genderInfoList.gender.id === 'homoromantic_male' ||
        genderInfoList.gender.id === 'homosexual_male' ||
        genderInfoList.gender.id === 'heterosexual_male' ||
        genderInfoList.gender.id === 'heteroromantic_male'
      ) {
        score = 100 - score
      }

      return `${score}%`
    },
    genderTypeClass() {
      const genderInfoList = this.genderInfoList
      return {
        'sexualities--sex': genderInfoList.genderTypeCode === 'sex',
        'sexualities--genderIdentity': genderInfoList.genderTypeCode === 'gender_identity',
        'sexualities--genderExpression': genderInfoList.genderTypeCode === 'gender_expression',
        'sexualities--sexualOrientation': genderInfoList.genderTypeCode === 'sexual_orientation',
        'sexualities--romanticOrientation': genderInfoList.genderTypeCode === 'romantic_orientation',
      }
    },
  },
  methods: {
    isDisplayAsBar(gender: Gender) {
      return gender.sliderType === mGender.SLIDER_TYPE.Bar
    },
  },
})
